import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import AddCampaignLayout from "../Form/AddCampaignLayout";
import DefineAudienceForm from "@/features/onboarding/components/Onboarding/Tailored/DefineAudienceForm";
import { X } from "lucide-react";

const AudienceModal = ({
  isOpen,
  onClose,
  onSave,
  registerSubmitHandler,
  onDataChange,
  audienceData,
  isSavingAudience,
}) => (
  <CustomModal isOpen={isOpen} onClose={onClose} width="950px">
    <div className="flex justify-end w-full">
      <button className="p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors" onClick={onClose}>
        <X size={20} className="text-gray-800 dark:text-gray-200" />
      </button>
    </div>
    <AddCampaignLayout
      variant="modal"
      title="Let's Define Your Target Audience"
      description="Take a moment to review and personalize your target audience."
      cancelButtonText="Cancel"
      saveButtonText="Save"
      saveButtonIcon={false}
      onCancel={onClose}
      onSaveAndNext={onSave}
      isSaving={isSavingAudience}
      children={
        <DefineAudienceForm
          registerSubmitHandler={registerSubmitHandler}
          onDataChange={onDataChange}
          initialValues={audienceData}
        />
      }
    />
  </CustomModal>
);

export default AudienceModal;
